import { gql } from '@apollo/client';

export interface IBlockPdfAsset {
  buttonText: string;
  asset: {
    url: string;
  };
}

export const BlockPdfAssetFragment = gql`
  fragment BlockPdfAsset on BlockPdfAsset {
    buttonText
    asset {
      url
    }
  }
`;
